(function(){'use strict';
function money(c){var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';try{return new Intl.NumberFormat('en-US',{style:'currency',currency:cur}).format(c/100)}catch(e){return '$'+(c/100).toFixed(2)}}
function openCart(){try{if(typeof window.upcartOpenCart==='function'){window.upcartOpenCart();return}}catch(e){}location.href='/cart'}
function wire(box){
  var data=JSON.parse(box.querySelector('script[data-lp-variants]').textContent);
  var sels=[].slice.call(box.querySelectorAll('select[data-opt]'));
  var priceEl=box.querySelector('[data-lp-price]'),cmpEl=box.querySelector('[data-lp-cmp]'),saveEl=box.querySelector('[data-lp-save]');
  var btn=box.querySelector('[data-lp-add]'),msg=box.querySelector('[data-lp-msg]');
  var current=null;
  function pick(){
    var want=sels.map(function(s){return s.value});
    current=null;
    for(var i=0;i<data.length;i++){var v=data[i],ok=true;
      for(var k=0;k<want.length;k++){if(String(v[4+k])!==String(want[k])){ok=false;break}}
      if(ok){current=v;break}}
    var avail=current&&current[1];
    if(priceEl&&current){priceEl.textContent=money(current[2])}
    if(cmpEl){var c=current?current[3]:0;cmpEl.textContent=c>current[2]?money(c):'';cmpEl.style.display=c>current[2]?'':'none';
      if(saveEl){saveEl.style.display=c>current[2]?'':'none';saveEl.textContent=c>current[2]?'Save '+Math.round((1-current[2]/c)*100)+'%':''}}
    btn.disabled=!avail;btn.textContent=avail?btn.getAttribute('data-label'):'Unavailable in that size';
    box.dispatchEvent(new CustomEvent('lp:variant',{detail:{variant:current,available:!!avail}}));
  }
  sels.forEach(function(s){s.addEventListener('change',pick)});
  pick();
  function add(){
    if(!current||!current[1])return;
    var was=btn.textContent;btn.disabled=true;btn.textContent='Adding…';if(msg)msg.textContent='';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:current[0],quantity:1}]})})
    .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
    .then(function(x){if(!x.ok)throw new Error((x.j&&(x.j.description||x.j.message))||'Could not add');btn.textContent='Added ✓';setTimeout(function(){btn.disabled=false;btn.textContent=was},1500);openCart()})
    .catch(function(e){btn.disabled=false;btn.textContent=was;if(msg)msg.textContent=e.message||'Something went wrong, please try again.'});
  }
  btn.addEventListener('click',add);
  box.lpAdd=add;
}
function ready(){
  var boxes=[].slice.call(document.querySelectorAll('[data-lp-buy]'));
  boxes.forEach(wire);
  var hero=document.querySelector('[data-lp-buy][data-primary]'),bar=document.querySelector('[data-lp-sticky]');
  if(hero&&bar&&'IntersectionObserver' in window){
    var bp=bar.querySelector('[data-lp-price]');
    hero.addEventListener('lp:variant',function(e){if(bp&&e.detail.variant)bp.textContent=money(e.detail.variant[2])});
    bar.querySelector('[data-lp-go]').addEventListener('click',function(){hero.lpAdd&&hero.lpAdd()});
    var sync=function(){var r=hero.getBoundingClientRect();bar.classList.toggle('show',r.bottom<0)};
    window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync);sync();
  }
  document.querySelectorAll('[data-lp-thumb]').forEach(function(t){t.addEventListener('click',function(){
    var g=t.closest('[data-lp-gallery]');g.querySelector('[data-lp-mainimg]').src=t.getAttribute('data-src');
    g.querySelectorAll('[data-lp-thumb]').forEach(function(x){x.classList.remove('on')});t.classList.add('on')})});
  document.querySelectorAll('[data-lp-top]').forEach(function(a){a.addEventListener('click',function(ev){ev.preventDefault();var h=document.querySelector('[data-lp-buy][data-primary]')||document.querySelector('[data-lp-buy]');if(h)h.scrollIntoView({behavior:'smooth',block:'center'})})});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();
